import { useEffect, useState } from 'react';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';

const fetchExperiences = (params) =>
  EcomEngineAPI.entry
    .getExperiences(params)
    .then((response) => Promise.resolve(response));

export const useExperienceFilter = (displayAllEntries) => {
  const [fetchedExperiences, setFetchedExperiences] = useState([]);
  // type status = 'idle'|'loading'|'succeed'|'failed';
  const [status, setStatus] = useState('idle');
  const [haveMoreExperiences, setHaveMoreExperiences] = useState(true);
  const [categoryIds, setCategoryIds] = useState(null);
  const [fetchAll, setFetchAll] = useState(displayAllEntries);

  useEffect(() => {
    const fetchData = () => {
      if (!categoryIds) {
        return;
      }
      setStatus('loading');
      const limit = fetchAll ? 0 : 6;
      fetchExperiences({
        categoryIds: categoryIds.filter((id) => id !== '0'),
        limit,
      })
        .then((res) => {
          setFetchedExperiences(res);
          if (res.length < 6) {
            setHaveMoreExperiences(false);
          } else {
            setHaveMoreExperiences(!fetchAll);
          }
          setStatus('succeed');
        })
        .catch((error) => {
          trackError(error);
          setStatus('failed');
        });
    };
    setFetchedExperiences([]);
    fetchData();
  }, [categoryIds, fetchAll]);

  return [
    fetchedExperiences,
    status,
    haveMoreExperiences,
    setCategoryIds,
    setFetchAll,
  ];
};
